import React, { useState, useMemo, useEffect, useRef } from 'react';

import NavLink from "./nav-link";

const NavItem = ({ currentPath, index, menuItem, setOpen, openChild, setOpenChild }) => {
    const [ height, setHeight ] = useState(null);
    const heightRef = useRef(null);

    const divHeight = useMemo(() => {

        if(openChild === menuItem.label) {
            return heightRef.current.clientHeight * menuItem?.children.length;
        }
        
        return 0;
    }, [menuItem, openChild]);
    
    useEffect(() => {
        setHeight(divHeight);
    }, [openChild]);

    const handleNavClick = (label) => {
        if(label === openChild) {
            setOpenChild(null)
            setHeight(0);
        }else{
            setOpenChild(label);
            setHeight(divHeight);
        }
    };
  
    return (
        <li
            className="nav-list-item"
            key={ `header-nav-${index}` }
        >
            { menuItem?.children.length === 0 ?
                <NavLink 
                    currentPath={currentPath}
                    menuItem={menuItem}
                    setOpen={setOpen}
                />
            :
                <div
                    className="parent-wrapper"
                    onClick={e => handleNavClick(menuItem.label)}
                >
                    <div
                        className="cross"
                    >
                        <span
                        className={`vertical-axis ${ menuItem.label === openChild ? "open" : "close" }`}
                        ></span>
                        <span
                        className="horizontal-axis"
                        ></span>
                    </div>
                    <div
                        className={`parent-title ${ menuItem.label === openChild ? "open" : "close" }`}
                    >
                        { menuItem.label }
                    </div>
                </div>
            }
            { menuItem && menuItem?.children.length !== 0 &&
                <ul
                    className={`nav-children ${ menuItem.label === openChild ? "open" : "close" }`}
                    style={{
                        height
                    }}
                >
                    { menuItem?.children.map((subMenuItem, subIndex) => {
                        return(
                            <li
                                className="nav-list-item"
                                ref={ heightRef }
                                key={ `header-sub-nav-${subIndex}` }
                            >
                                <NavLink 
                                    currentPath={currentPath}
                                    menuItem={subMenuItem}
                                    setOpen={setOpen}
                                />
                            </li>
                        )
                    })}
                </ul>
            }
      </li>
    );
};
  
export default NavItem;  